// Suspense fallback shown while a lazy page chunk loads. Sized to the
// post-AuthGate viewport so the swap doesn't shift the AppShell chrome.
// Pulses a single skeleton block — operators visually parse this as
// "page is loading" rather than "session is gone".

export function PageSkeleton() {
  return (
    <div className="px-5 py-4 max-w-[1920px] mx-auto" role="status" aria-label="Loading">
      <div className="h-7 w-48 rounded bg-[var(--bg-surface)] animate-pulse mb-4" />
      <div className="grid gap-3 lg:grid-cols-[1fr_minmax(380px,520px)]">
        <div className="space-y-3">
          <div className="h-[420px] rounded-lg border border-[var(--border-subtle)] bg-[var(--bg-surface)] animate-pulse" />
          <div className="h-32 rounded-lg border border-[var(--border-subtle)] bg-[var(--bg-surface)] animate-pulse" />
        </div>
        <div className="h-[80dvh] rounded-lg border border-[var(--border-subtle)] bg-[var(--bg-surface)] animate-pulse" />
      </div>
    </div>
  );
}
